var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9284 3.71272L20.7873 9.5716C21.5638 10.3483 22 11.4017 22 12.5C22 13.5983 21.5638 14.6517 20.7873 15.4284L14.9284 21.2873C14.1517 22.0638 13.0983 22.5 12 22.5C10.9017 22.5 9.84834 22.0638 9.0716 21.2873L3.21272 15.4284C2.43622 14.6517 2 13.5983 2 12.5C2 11.4017 2.43622 10.3483 3.21272 9.5716L9.0716 3.71272C9.84834 2.93622 10.9017 2.5 12 2.5C13.0983 2.5 14.1517 2.93622 14.9284 3.71272ZM11.3104 9.73935C10.7611 9.73935 10.2343 9.95754 9.84593 10.3459C9.45754 10.7343 9.23935 11.2611 9.23935 11.8104V13.1896C9.23935 13.7389 9.45754 14.2657 9.84593 14.6541C10.2343 15.0425 10.7611 15.2606 11.3104 15.2606H12.6896C13.2389 15.2606 13.7657 15.0425 14.1541 14.6541C14.5425 14.2657 14.7606 13.7389 14.7606 13.1896V11.8104C14.7606 11.2611 14.5425 10.7343 14.1541 10.3459C13.7657 9.95754 13.2389 9.73935 12.6896 9.73935H11.3104Z",
    fill: "#FF8C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.8144daf6f80c7cd880a8afa466cda55d.svg";
export { ForwardRef as ReactComponent };